export default function ErrorBanner({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div style={{
      border: "1px solid #ef4444",
      background: "#fee2e2",
      color: "#991b1b",
      padding: 12,
      borderRadius: 10,
      margin: "12px 0"
    }}>
      {message}
    </div>
  );
}
